import type { SupportedAgent } from "@src/gql/graphql";

export const supportedAgentsQueryKeys = {
	all: ["supportedAgents"] as const,
} as const;

export type ContextStatsQueryArgs = {
	promptCardId: string;
	contentCardIds: string[];
	parentWhiteboardId?: string;
	agent?: SupportedAgent;
	shareKey?: string;
	expandReferences?: boolean;
};

export const contextStatsQueryKeys = {
	byCard: (args: ContextStatsQueryArgs) =>
		[
			"contextStats",
			args.promptCardId,
			[...args.contentCardIds].sort(),
			args.parentWhiteboardId,
			args.agent,
			args.shareKey,
			args.expandReferences,
		] as const,
};
